import BaseApi from '../BaseApi';
import { BonusProgramConverter } from './BonusProgramConverter';

class BonusProgramApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.converter = new BonusProgramConverter();
  }

  createGift = data => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/gift/create`, data);

  editGift = data => this.sendQuery(this.queryTypes.PUT, `${this.baseUrl}/gift/update/${data?.get('id')}/`, data);

  getCurrentGifts = data =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/gift/list`, data, null, this.converter.convertCurrentGifts);

  getGiftRequests = data =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/gift_request/list`,
      data,
      null,
      this.converter.convertRequests,
    );

  changeGiftRequest = ({ id, ...data }) =>
    this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/gift_request/update_status/${id}/`, data);

  deleteGift = ({ id }) => this.sendQuery(this.queryTypes.DELETE, `${this.baseUrl}/gift/delete/${id}`, data);

  getChristmasTournament = data =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/christmas_tournament`,
      null,
      null,
      this.converter.convertChristmasTournament,
    );

  getJacktopTournament = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/agents_jacktop_tournament`,
      null,
      null,
      this.converter.convertJacktopTournament,
    );

  getRubyPlayTournament = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/agents_rubyplay_tournament`,
      null,
      null,
      this.converter.convertRubyPlayTournament,
    );
    
  getNetentTournament = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/agents_outcome_tournament`,
      null,
      null,
      this.converter.convertNetentTournament,
    );

  getPromotions = data =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/promotions`, data, null, this.converter.convertPromotions);

  createPromotion = data => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/promotions`, data);

  editPromotion = (id, data) => this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/promotions/${id}/`, data);

  deletePromotion = id => this.sendQuery(this.queryTypes.DELETE, `${this.baseUrl}/promotions/${id}/`);

  getPromotionById = id =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/promotions/${id}/`,
      null,
      null,
      this.converter.convertPromotionById,
    );
}

export default BonusProgramApi;
